// extracted by mini-css-extract-plugin
var _1 = "contentBlock__YsH72";
var _2 = "item__WuVDy";
var _3 = "number__vriey";
var _4 = "subtitle__qm2wD";
var _5 = "title__kjoCb";
var _6 = "titleWrapper__NiCDt";
export { _1 as "contentBlock", _2 as "item", _3 as "number", _4 as "subtitle", _5 as "title", _6 as "titleWrapper" }
export default { "contentBlock": _1, "item": _2, "number": _3, "subtitle": _4, "title": _5, "titleWrapper": _6 }
